import React from "react";
import * as Assets from "./assets";

export interface Props {
  name:
    | "arrowBack"
    | "arrowDown"
    | "close"
    | "done"
    | "download"
    | "favorite"
    | "home"
    | "errorLocal"
    | "errorServer"
    | "inputDelete"
    | "play"
    | "ratio_1_1"
    | "ratio_16_9"
    | "ratio_9_16"
    | "search"
    | "share"
    | "time"
    | "ImgDownload";
  size?: number;
}

const IconView = ({ name, size = 16 }: Props) => {
  const props = {
    width: size,
    height: size,
  };

  if (name === "ratio_1_1") {
    return <img src={Assets.ImgRatio11} alt="ratio_1_1" {...props} />;
  } else if (name === "ratio_16_9") {
    return <img src={Assets.ImgRatio169} alt="ratio_16_9" {...props} />;
  } else if (name === "ratio_9_16") {
    return <img src={Assets.ImgRatio916} alt="ratio_9_16" {...props} />;
  } else if (name === "time") {
    return <img src={Assets.ImgTime} alt="time" {...props} />;
  } else if (name === "arrowBack") {
    return <Assets.SvgArrowBack {...props} />;
  } else if (name === "arrowDown") {
    return <Assets.SvgArrowDown {...props} />;
  } else if (name === "close") {
    return <Assets.SvgClose {...props} />;
  } else if (name === "done") {
    return <Assets.SvgDone {...props} />;
  } else if (name === "download") {
    return <img src={Assets.ImgDownload} alt="time" {...props} />;
    // return <Assets.SvgDownload {...props} />;
  } else if (name === "errorLocal") {
    return <Assets.SvgErrorLocal {...props} />;
  } else if (name === "errorServer") {
    return <Assets.SvgErrorServer {...props} />;
  } else if (name === "favorite") {
    return <Assets.SvgFavorite {...props} />;
  } else if (name === "home") {
    return <Assets.SvgHome {...props} />;
  } else if (name === "inputDelete") {
    return <Assets.SvgInputDelete {...props} />;
  } else if (name === "play") {
    const width = size - 4;
    const height = size;
    return <Assets.SvgPlay width={width} height={height} />;
  } else if (name === "search") {
    return <Assets.SvgSearch {...props} />;
  } else if (name === "share") {
    return <Assets.SvgShare {...props} />;
  }

  return null;
};

export default IconView;
